<template>
  <b-row>
    <b-col sm="12" md="6" :lg="lg">
      <table class="table table-stripped" width="100%">
        <thead>
          <tr>
            <th colspan="2">
              {{Core.Definition.getDefinition('Heures de rappel')}}
            </th>
            <th>
              <b-link @click="addTime" href="#" class="card-header-action btn-setting">
                <i class="fa fa-plus mr-1"></i>{{Core.Definition.getDefinition('Heure de rappel')}}
              </b-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr :key="timeIndex" v-for="time, timeIndex in dataValue.times">
            <td>
              {{Core.Definition.getDefinition('Rappel #') + (timeIndex + 1)}}
            </td>
            <td>
              <InputTime
                      class="p-0 m-0"
                      :minuteInterval="15"
                      v-model="dataValue.times[timeIndex]">
              </InputTime>
              <small v-if="!Core.Validation.isEmpty(dataValue.times[timeIndex])" class="p-0 m-0">{{Core.Text.format(Core.Definition.getDefinition('Envoyé {0} avant l\'événement'), Core.Value.readable(Core.Value.typeTime, '', dataValue.times[timeIndex]))}}</small>
            </td>
            <td>
              <b-button type="button" @click="trasTime(timeIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></b-button>
            </td>
          </tr>
          <tr v-if="dataValue.times.length == 0">
            <td colspan="3">
              <b-alert show variant="light">
                {{Core.Definition.getDefinition('Aucun rappel pour cet événement')}}
              </b-alert>
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>
    <b-col sm="12" md="6" :lg="lg">
      <InputSelect
              :search="false"
              :options="Mantle.Reminder.getModelOptions()"
              :label="Core.Definition.getDefinition('Modèle de message')"
              v-model="dataValue.model.option"></InputSelect>

      <InputEditor
              v-show="dataValue.model.option === Mantle.Reminder.modelCustom"
              :label="Core.Definition.getDefinition('Message personnalisé')"
              v-model="dataValue.model.text"></InputEditor>

      <b-alert v-if="dataValue.model.option === Mantle.Reminder.modelSystemConfig" show variant="light">
        {{Core.Definition.getDefinition('Message général tel que défini dans les paramètres. Système -> Paramètres -> Notifications automatiques')}}
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
  import InputSelect from './InputSelect'
  import InputEditor from './InputEditor'
  import InputTime from './InputTime'
  export default {
    name: 'Reminder',
    components: {
      InputSelect,
      InputEditor,
      InputTime
    },
    props: {
      value: {
        type: Object,
        default: function() {
          return {}
        }
      },
      lg: {
        type: Number,
        default: 6
      }
    },
    watch: {
      value(val) {
        this.dataValue = val
      },
      'dataValue': {
        handler(val) {
          this.dataValue = val
        },
        deep: true
      },
    },
    mounted() {
      this.dataValue = this.value
    },
    data: () => {
      return {
        Core: window.Core,
        Mantle: window.Mantle,
        dataValue: {
          times: [],
          model: {
            option: Mantle.Reminder.modelSystemConfig,
            text: ''
          }
        }
      }
    },
    methods: {
      addTime() {
        this.dataValue.times.push('')
      },
      trasTime(timeIndex) {
        this.dataValue.times.splice(timeIndex,1)
      }
    }
  }
</script>
